// Home.js (replace your existing Home file with this content)

import React, { Component, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, Alert, FormControl, Container, Row, Col } from "react-bootstrap";
import Carousel from "../../Parts/Home/crousel";
import { keyframes } from "styled-components";
import { Helmet } from "react-helmet";
import Popular from "./Popular";
import Games from "./Games";
import Slots from "../../../Slots/Slots";
import {
  BRAND,
  decode,
  encode,
  getUID,
  isMobile,
  sendNotfication,
} from "../../../../Helper";
import { withCookies } from "react-cookie";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";

// ===== CAROUSEL COMPONENTS =====
import CustomSlider from "../../../Components/CustomSlider";
import GameCarousel from "../../../Components/CarouselGame";
import SkylaSlider from "../../../Components/SkylaBannerSlider";
import SkylaPromoSlider from "../../../Components/SkylaPromoSlider";
import Banner from "../../../Components/Banner";
// ================================

import BannerGames from "../../../Components/BannerGames";
import GameList from "../../HomeOrignals";
import CasinoLeaderboard from "../../../Components/HelloGamesTable";
import { ChevronLeft, ChevronRight, Play } from "lucide-react";
import LatestWins from "../../../Components/LatestWins";
import GamingCards from "../../../Components/GamingCards";
import SkylaGameCards from "../../../Components/SkylaGamingCard";

import PaymentBar from "../../../Components/PaymentBar";
import MobilePaymentBR from "../../../Components/MobilePaymetBar";
import C from "../../../../../src/Constant";
import socket from "../../../../Socket";
import storage from "../../../../Storage";
import { useSiteConfig } from "../../../../hooks/useSiteConfig";
import GameIframe from "../../../../Context/GameIframe";
import GameProviders from "./Provider";
import Esports from "../../../Components/Esports";
import LobbySection from "../../../Components/Lobby";
import { useSelector } from "react-redux";
import SportsBanner from "../../../Components/sportbanner/sportbanner";
import Sports from "../../../Components/sportbanner";
import PgSoftProvider from "./ProviderGames/PgSoftProvider";
import {
  fetchHuiduSuppliers,
  fetchHuiduGames,
  launchHuiduGame,
} from "../../../../services/huiduGameService";
import {
  getGameRangeForProvider,
  getCustomImagesForProvider,
  filterAndOrderSuppliers,
  getProviderConfig,
} from "../../../../config/huiduProviderConfig";
import HOME_GAMES_CONFIG from "../../../../config/homeGamesConfig";
import HOT_GAMES_CONFIG from "../../../../config/hotGamesConfig";
import { ContactSupportOutlined, FlareSharp } from "@mui/icons-material";

// ----------------- Top-level utilities (sanitize + cache helpers) -----------------
function sanitizeKey(provider) {
  return String(provider)
    .replace(/\s+/g, "_")
    .replace(/[^a-zA-Z0-9_]/g, "");
}
function now() {
  return Date.now();
}
function setLocalCache(key, value, ttl = 300000) {
  try {
    const payload = { ts: now(), ttl, data: value };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (err) {
    console.warn("setLocalCache failed", key, err);
  }
}
function getLocalCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.ts || typeof parsed.ttl !== "number") return null;
    if (now() - parsed.ts > parsed.ttl) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch (err) {
    console.warn("getLocalCache failed", key, err);
    return null;
  }
}
function clearLocalCache(key) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    /* ignore */
  }
}

// ----------------- Styled components (kept from your original file) -----------------
const FullScreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100001;
  background-color: #292d2e;
`;
const FullScreenIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  display: ${(props) => (props.loading ? "none" : "block")};
`;
const ResponsiveImage = styled.img`
  object-fit: cover;
  width: 140px;
  height: 140px;
  border-radius: 20px;

  @media (min-width: 467px) {
    width: 188px;
    height: 188px;
  }
`;

// ─── LazySection: defers rendering until near viewport (saves mobile CPU/memory) ───
class LazySection extends React.Component {
  constructor(props) {
    super(props);
    // First section renders eagerly; rest wait for scroll
    this.state = { visible: !!props.eager };
    this.ref = React.createRef();
    this.observer = null;
  }

  componentDidMount() {
    if (this.state.visible) return; // already visible (eager)
    this.observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ visible: true });
          this.observer.disconnect();
        }
      },
      { rootMargin: "400px 0px" }, // start rendering 400px before visible
    );
    if (this.ref.current) this.observer.observe(this.ref.current);
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  render() {
    const { children, minHeight = 300 } = this.props;
    return (
      <div ref={this.ref}>
        {this.state.visible ? (
          children
        ) : (
          <div
            style={{
              height: minHeight,
              background:
                "linear-gradient(90deg, #2a2f30 25%, #323839 37%, #2a2f30 63%)",
              backgroundSize: "400% 100%",
              animation: "skeleton-loading 1.4s ease infinite",
              borderRadius: 8,
              margin: "6px 0",
            }}
          />
        )}
      </div>
    );
  }
}

// Helper function to get fallback image
const getImageWithFallback = (imageSrc) => {
  if (!imageSrc) {
    return "/assets/images/default_card3.png";
  }
  return imageSrc;
};

// Enhanced GameImage component with error handling
const GameImageWithFallback = ({ src, alt, ...props }) => {
  const [imgSrc, setImgSrc] = useState(getImageWithFallback(src));
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc("/assets/images/default_card3.png");
    }
  };

  useEffect(() => {
    setImgSrc(getImageWithFallback(src));
    setHasError(false);
  }, [src]);

  return (
    <GameImage
      src={imgSrc}
      alt={alt}
      onError={handleError}
      loading="lazy"
      {...props}
    />
  );
};

// many styled components kept as-is (omitted earlier duplicates)...
const BackButton = styled.button`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  background: none;
  border: none;
  color: #000;
  font-size: 24px;
  cursor: pointer;
`;
const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #000;
`;
// ... (keep the rest of your existing styled components exactly as you had them)
const SliderContainer = styled.div`
  width: 100%;
  max-width: 800px;
  position: relative;
  overflow: hidden;
`;
const SliderTrack = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${(props) => props.translate}%);
`;
const SliderItem = styled.div`
  flex: 0 0 100%;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  background-color: #f2f2f2;
`;
const SliderNavigation = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
`;
const NavigationButton = styled.button`
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  outline: none;
  font-size: 24px;
  padding: 10px;
  cursor: pointer;
`;
const LottoCard = styled.button` background-color: #292d2e; border-radius:12px; width:100% margin-bottom:12px; `;
const ContainerPlay = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    justify-content: center;
  }
  @media (max-width: 767px) {
    gap: 8px;
  }
`;
const SkeletonLoader = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(190, 190, 190, 0.2) 25%,
    rgba(129, 129, 129, 0.24) 37%,
    rgba(190, 190, 190, 0.2) 63%
  );
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
  border-radius: 8px;
  @keyframes skeleton-loading {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;
const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 12px;
  @media (max-width: 767px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const PickOptionWrapper = styled.div`
  flex: 0 0 auto;
  width: calc(50% - 6px);
  scroll-snap-align: start;
  @media (min-width: 768px) {
    width: 100%;
  }
`;
const HiddenOnSmallScreens = styled.div`
  display: flex;
  @media (max-width: 768px) {
    display: none;
  }
`;
const GamesWrapper = styled.div`
  background-color: #292d2e;
  padding: 2px;
  border-radius: 0 20px 20px 20px;
  position: relative;
  margin-top: 40px !important;
  @media (max-width: 768px) {
    margin-top: 100px !important;
  }
`;
const GamesTopWrapper = styled.div`
  background-color: #292d2e;
  padding: 2px;
  border-radius: 0 20px 20px 20px;
  position: relative;
  margin-top: 40px !important;
  margin-top: 100px !important;
  @media (max-width: 768px) {
    margin-top: 100px !important;
  }
`;
const GridContainer = styled.div`
  display: grid;
  gap: 10px;
  padding: 0rem;
  margin: 12px 12px;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;
const GridItem = styled.div`
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;
const GridContainerNew = styled.div`
  display: grid;
  gap: 10px;
  padding: 0rem;
  margin: 12px 12px;
  width: 100%;
  padding-right: 17px;
  grid-template-columns: repeat(2, 1fr) !important;
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr) !important;
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, 1fr) !important;
  }
`;
const GridItemNew = styled.div`
  background-color: transparent;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
`;
const AllButtonTopTitleContainer = styled.div`
  background-color: #292d2e;
  border-radius: 15px;
  display: flex;
  justify-caontent: center;
  align-items: center;
  color: #7f898c;
  font-weight: bold;
  z-index: 1;
  padding: 5px 23px;
  margin: 0;
  cursor: pointer;
`;
const NavItem = styled.button`
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.active ? "#292d2e" : "transparent")};
  color: ${(props) => (props.active ? "#ffffff" : "#888888")};
  border: none;
  padding: 12px 16px;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
  &:hover {
    background-color: #2a2a2a;
  }
`;
const NavBar = styled.nav`
  display: inline-flex;
  justify-content: flex-end;
  background-color: #292d2e;
  padding: 4px;
  border-radius: 26px;
  overflow: hidden;
`;
const NavBarEnd = styled.div`
  display: flex;
  width: 100%;
`;
const TabSwitcher = styled.div`
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const GameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.2s ease;
`;
const Tab = styled.button`
  background-color: ${(props) => (props.active ? "#333839" : "transparent")};
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 26px;
  cursor: pointer;
  font-size: 16px;
  margin-right: 10px;
  white-space: nowrap;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: ${(props) => (props.active ? "#333839" : "#292d2e")};
  }
`;
const FlexArrange = styled.div`
  display: flex;
  align-items: center;
`;
const TabImage = styled.img`
  height: 28px;
  width: 28px;
  object-fit: contain;
  margin-right: 8px;
  filter: ${(props) => (props.active ? "none" : "grayscale(100%)")};
  transition: filter 0.3s ease;
`;
const TabText = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`;
const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const HeaderContent = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 12px 0px;
`;
const IconBg = styled.div`
  padding: 6px 8px;
  background-color: #292d2e;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    background-color: #4a5354;
  }
`;
const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;
const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 11px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const GameCard = styled.div`
  min-width: 142px;
  height: 195px;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;
  &:hover {
    ${GameOverlay} {
      opacity: 1;
    }
    transform: translateY(-5px);
  }
  @media (max-width: 768px) {
    min-width: 115px;
    height: 165px;
  }
`;
const LotteryGameCard = styled.div`
  min-width: 142px;
  height: 106px;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: transform 0.2s ease;
  &:hover {
    ${GameOverlay} {
      opacity: 1;
    }
    transform: translateY(-5px);
  }
  @media (max-width: 768px) {
    min-width: 115px;
    height: 80px;
  }
`;
const GameImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  &:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease-out;
  }
  &[src*="default_card.png"] {
    background-color: #f0f0f0;
    border: 1px solid #ddd;
  }
`;
const LotteryGameImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;
const PlayIconContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const PlayIcon = styled(Play)`
  color: #fff;
  font-size: 24px;
`;
const TopTitle = styled.div`
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-left: 4px;
`;
const ProviderLogo = styled.img`
  object-fit: contain;
  height: 1.6rem;
  width: 80%;
`;
const ProviderWrapper = styled.div`
  margin-top: 50px !important;
  margin-bottom: 50px !important;
`;
const ProviderHeadingWrapper = styled.div`
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
`;
const ProviderGridContainer = styled.div.attrs({
  className: "provide-grid-container",
})`
  display: grid;
  gap: 1px;
  background: #292d2e;
  padding: 1px;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 767px) {
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 1fr);
    grid-auto-columns: minmax(100px, 1fr);
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    grid-auto-flow: column;
    grid-template-rows: repeat(2, 1fr);
    grid-auto-columns: minmax(150px, 1fr);
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(9, 1fr);
    grid-template-rows: repeat(2, 1fr);
    overflow: hidden;
  }
`;
const ProviderGridItem = styled(Link)`
  background: #292d2e;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 8px;
  scroll-snap-align: start;
  @media (max-width: 1023px) {
    aspect-ratio: 16 / 9;
  }
`;
const LotteryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;
const LotteryInfo = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: white;
`;
const LotteryTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
`;
const LotteryPrize = styled.div`
  font-size: 14px;
  color: #25ee89;
  margin-top: 4px;
`;
const skeletonAnimation = keyframes` 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } `;
const SkeletonCard = styled.div`
  width: 120px;
  height: 150px;
  border-radius: 8px;
  background: linear-gradient(90deg, #292d2e 25%, #2a2a2a 50%, #292d2e 75%);
  background-size: 200% 100%;
  animation: ${skeletonAnimation} 1.2s ease-in-out infinite;
`;
const LoadMoreButton = styled.button`
  background-color: #292d2e;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  margin: 20px auto;
  display: block;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #4a5354;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;
const PaginationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  background-color: ${(props) => (props.disabled ? "#3a3a3a" : "#4a4a4a")};
  color: ${(props) => (props.disabled ? "#777" : "white")};
  border: none;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background-color: ${(props) => (props.disabled ? "#3a3a3a" : "#5a5a5a")};
  }
`;
const PaginationInfo = styled.div`
  color: white;
  font-size: 14px;
`;
const Spinner = styled.div`
  width: ${(props) => (props.size === "sm" ? "16px" : "24px")};
  height: ${(props) => (props.size === "sm" ? "16px" : "24px")};
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// ----------------- Provider lists & feature map -----------------

const GIS_PROVIDERS = [
  "Ezugi",
  "Spribe",
  "Live88",
  "Lotto Instant Win",
  "ICONIC21",
  "HoGaming",
  "No Limit City",
  "BGaming",
  "OneTouch",
  "JiliGames",
  "JDB",
  "Platipus",
  "Caleta",
  "Boldplay",
];
//'Lucksome','Platipus','NoLimitCity','Hacksaw Gaming','Lucksome'
const FEATURE_MAP = {
  Ezugi: "ezugi",
  Spribe: "spribe",
  "Lotto Instant Win": "Lotto",
  JDB: "JDB",
  BGaming: "BGaming",
  OneTouch: "OneTouch",
  "Hacksaw Gaming": "Hacksaw_Gaming",
  Caleta: "Caleta",
  Boldplay: "Boldplay",
  Lucksome: "Lucksome",

  BGaming: "bgaming",
  JiliGames: "jili",
  NetEnt: "netent",

  Live88: "live88",

  Octoplay: "Octoplay",

  "No Limit City": "NoLimitCity",

  // mappings for newly added providers
  ICONIC21: "ICONIC21",
  HoGaming: "HoGaming",

  "No Limit City": "NoLimitCity",
};

// ----------------- Home class component -----------------
class Home extends Component {
  constructor(props) {
    super(props);

    const loggedStatus = localStorage.getItem("logged") === "true";

    this.state = {
      padding: "py-2",
      selectedSection: "home",
      sectionIndex: 0,
      slideSelected: null,
      vendorPagination: {
        OneTouch: { currentPage: 1, totalPages: 1, loading: false },
        pragmatic: { currentPage: 1, totalPages: 1, loading: false },
        pragmaticlive: { currentPage: 1, totalPages: 1, loading: false },
        spribe: { currentPage: 1, totalPages: 1, loading: false },
        ezugi: { currentPage: 1, totalPages: 1, loading: false },
        ideal: { currentPage: 1, totalPages: 1, loading: false },
        microgaming: { currentPage: 1, totalPages: 1, loading: false },
        Caleta: { currentPage: 1, totalPages: 1, loading: false },
        hacksaw: { currentPage: 1, totalPages: 1, loading: false },
        jili: { currentPage: 1, totalPages: 1, loading: false },
        netent: { currentPage: 1, totalPages: 1, loading: false },
        hotgames: { currentPage: 1, totalPages: 1, loading: false }, // added hotgames as referenced in JSX
        hotgames_old: { currentPage: 1, totalPages: 1, loading: false }, // placeholder if needed
        hotgames2: { currentPage: 1, totalPages: 1, loading: false },
        hotgames3: { currentPage: 1, totalPages: 1, loading: false },
        Caleta: { currentPage: 1, totalPages: 1, loading: false },
        Boldplay: { currentPage: 1, totalPages: 1, loading: false },
        live88: { currentPage: 1, totalPages: 1, loading: false },
        sevenMojos: { currentPage: 1, totalPages: 1, loading: false },
        Octoplay: { currentPage: 1, totalPages: 1, loading: false },
        JDB: { currentPage: 1, totalPages: 1, loading: false },
        NoLimitCity: { currentPage: 1, totalPages: 1, loading: false },
        Hacksaw_Gaming: { currentPage: 1, totalPages: 1, loading: false },
        Lucksome: { currentPage: 1, totalPages: 1, loading: false },
        Evolution: { currentPage: 1, totalPages: 1, loading: false },
        Lotto: { currentPage: 1, totalPages: 1, loading: false },
        ICONIC21: { currentPage: 1, totalPages: 1, loading: false },
        HoGaming: { currentPage: 1, totalPages: 1, loading: false },
        BGaming: { currentPage: 1, totalPages: 1, loading: false },
      },
      enabledFeatures: {
        OneTouch: false,
        pragmaticslots: false,
        pragmaticslive: false,
        ideal: false,
        bonus: false,
        microgaming: false,
        Pgsoft: false,
        esport: false,
        lobby: false,
        Hacksaw: false,
        bgaming: false,
        jili: false,
        spribe: false,
        netent: false,
        bjboriginal: false,
        Boldplay: false,
        live88: false,
        sevenMojos: false,
        Octoplay: false,
        Evolution: false,
        JDB: false,
        NoLimitCity: false,
        Hacksaw_Gaming: false,
        Lucksome: false,
        Caleta: false,
        Lotto: true,
        // enable defaults for newly added providers
        ICONIC21: true,
        HoGaming: true,
        BGaming: true,
      },
      // many arrays kept...
      gamesEvolution: [],
      gamesPragmatic: [],
      gamesPragmaticlive: [],
      gamesEvoplay: [],
      gamesGenisis: [],
      gamesPgsoft: [],
      gamesLiveCasinoProvider: [],
      gamesSpribe: [],
      gamesSports: [],
      gamesMostExpensive: [],
      xGamingNetent: [],
      xGamingPragamticPlay: [],
      xGamingAviator: [],
      xGamingEvolution: [],
      xGamingPgSoft: [],
      xGamingLottery: [],
      xGamingIndian: [],
      xGamingCrash: [],
      xGamingBetGames: [],
      xGaminglive88: [],
      xGamingSevenMojos: [],
      xGamingSexyBaccarat: [],
      xGamingOctoplay: [],
      xGamingEvolution: [],
      xGamingPragmaticPlay: [],
      xGamingSpadegaming: [],
      xGamingNoLimitCity: [],
      xGamingPlatipus: [],
      xGamingVivoGame: [],
      xGamingkAGame: [],
      xGamingJili: [],
      xCrashGames: [],
      jsEvolution: [],
      jsPragmeticSlots: [],
      jsPragamaticLive: [],
      jsSpribe: [],
      jsLotto: [],
      jsEzugi: [],
      jsIdeal: [],
      jsBGaming: [],
      jsMicrogaming: [],
      jsDpesports: [],
      jsPgsoft: [],
      jsTwoj: [],
      jsHacksaw: [],
      jsJili: [],
      jsNetent: [],
      jsOctoplay: [],
      jsEvolution: [],
      jsPragmaticPlay: [],
      jsSpadegaming: [],
      jsNoLimitCity: [],
      jsPlatipus: [],
      jsBgaming: [],
      jsLotto: [],
      jsICONIC21: [],
      jsHoGaming: [],
      jsHotGames: [],
      // HUIDU games state
      huiduSuppliers: [],
      huiduGames: {}, // { supplierCode: [games...] }
      huiduPagination: {}, // { supplierCode: { loading, current_page, total_pages } }
      huiduShowMore: {}, // { supplierCode: boolean }
      huiduLoading: false,
      showMoreEzugi: false,
      showMoreIdeal: false,
      showMoreMicrogaming: false,
      showMoreDpesports: false,
      showMorePgsoft: false,
      showMoreTwoj: false,
      showMoreLotto: false,
      showMoreHackSaw: false,
      showMoreJsJili: false,
      showMoreJsNetent: false,
      showMoreJsOctoplay: false,
      showMoreEvolution: false,
      showMoreJsPragmaticPlay: false,
      showMoreJsSpadegaming: false,
      showMoreJsNoLimitCity: false,
      showMoreJsPlatipus: false,
      showMoreJsLive88: false,
      showMoreJsSevenMojos: false,
      showMoreJsSexyBaccarat: false,
      showMoreJsBgaming: false,
      showMoreHotGames: false,
      error: null,
      loading: false,
      message: null,
      loading1: false,
      showMore: false,
      showMoreP: false,
      showMoreO: false,
      showMoreLCP: false,
      showMoreSP: false,
      showMoreSB: false,
      showMoreEvo: false,
      showMoreLivecasino: false,
      showMoreAllSots: false,
      showMoreVivo: false,
      showMoreBetGame: false,
      showMoreka: false,
      showMoreLive88: false,
      showMoreJili: false,
      isMobileView: window.innerWidth <= 768,
      searchQuery: "",
      showIframe: false,
      iframeUrl: "",
      iframeLoading: true,
      showAll: false,
      showAllIndian: false,
      showPragamatic: false,
      showAllData: false,
      isLogged: loggedStatus,
      activeItem: "Lobby",
      canScrollLeft: false,
      canScrollRight: true,
      crashPage: 1,
      live88Page: 1,
      isLoadingMore: false,
      lotteryPage: 1,
      isLoadingMoreLottery: false,
      displayGamesLotteryXgaming: [],
      vivoPage: 1,
      isLoadingMoreVivo: false,
      displayGamesVivoXgaming: [],
      betGamePage: 1,
      isLoadingMoreBetGame: false,
      displayGamesBetGameXgaming: [],
      kaPage: 1,
      isLoadingMoreKa: false,
      displayGamesKaXgaming: [],
      evolutionPage: 1,
      indianPage: 1,
      isLoadingMoreEvolution: false,
      isLoadingMoreIndian: false,
      displayGamesEvolutionXgaming: [],
      displayGamesIndianXgaming: [],
      pragmaticPage: 1,
      isLoadingMorePragmatic: false,
      allPragmaticPlay: [],
      netentPage: 1,
      OctoplayPage: 1,
      Evolutionpage: 1,
      Lucksome: 1,
      SpadegamingPage: 1,
      NoLimitCityPage: 1,
      PlatipusPage: 1,
      Live88Page: 1,
      Lotto: 1,
      HoGaming: 1,
      ICONIC21: 1,
      BGaming: 1,
      SexyBaccaratPage: 1,
      SevenMojosPage: 1,
      NoLimitCityPage: 1,
      isLoadingMoreLive88: false,
      isLoadingMoreSevenMojos: false,
      isLoadingMoreNoLimitCity: false,
      isLoadingMoreSexyBaccarat: false,
      allLive88Games: [],
      allSevenMojosGames: [],
      allSexyBaccaratGames: [],
      pgPage: 1,
      isLoadingMoreNetent: false,
      isLoadingMoreOctoplay: false,
      isLoadingMorePragmaticPlay: false,
      isLoadingMoreSpadegaming: false,
      isLoadingMoreNoLimitCity: false,
      isLoadingMorePlatipus: false,
      isLoadingMorePg: false,
      isLoadingMoreSlots: false,
      allNetentGames: [],
      allOctoplayGames: [],
      allEvolutionGames: [],
      allPragmaticPlayGames: [],
      allSpadegaming: [],
      allNoLimitCityGames: [],
      allPlatipusGames: [],
      allPgGames: [],
      loadedLiveCasinoImages: new Set(),
      loadedPragmeticImage: new Set(),
      isLoadGames: true,
      gisGames: {}, // will hold sanitized keys
      gisPagination: {}, // hold sanitized keys
      showMoreGis: {},
    };

    // create many refs and safe placeholders
    this.gridRef = React.createRef();
    this.containerPlayRef = React.createRef();
    this.scrollContainerRef = React.createRef();
    this.scrollContainerLiveRef = React.createRef();
    this.scrollContainerLiveAllRef = React.createRef();
    this.scrollContainerSpribeRef = React.createRef();
    this.scrollContainerLiveCasinoRef = React.createRef();
    this.scrollContainerSlotsRef = React.createRef();
    this.scrollContainerAllSlotsRef = React.createRef();
    this.scrollContainerEvolutionGaminingRef = React.createRef();
    this.scrollContainerCrashRef = React.createRef();
    this.scrollContainerVivo = React.createRef();
    this.scrollContainerLive88 = React.createRef();
    this.scrollContainerKa = React.createRef();
    this.scrollContainerJili = React.createRef();
    this.scrollContainerBetGame = React.createRef();
    this.notificationCounter = 0;
    this.scrollContainerLotteryRef = React.createRef();
    this.scrollContainerPraRef = React.createRef();
    this.scrollContainerEzugiRef = React.createRef();
    this.scrollContainerIdealRef = React.createRef();
    this.scrollContainerMicrogamingRef = React.createRef();
    this.scrollContainerDpesportsRef = React.createRef();
    this.scrollContainerPgsoftRef = React.createRef();
    this.scrollContainerTwojRef = React.createRef();
    this.scrollContainerHackSawRef = React.createRef();
    this.scrollContainerJsJiliRef = React.createRef();
    this.scrollContainerJsBgamingRef = React.createRef();
    this.scrollContainerJsNetentRef = React.createRef();
    this.scrollContainerHotGamesRef = React.createRef();
    this.scrollContainerSexyBaccaratRef = React.createRef();
    this.scrollContainerSevenMojosRef = React.createRef();
    this.scrollContainerOctoplayRef = React.createRef();
    this.scrollContainerEvolutionRef = React.createRef();
    this.scrollContainerPlatipusRef = React.createRef();
    this.scrollContainerNoLimitCityRef = React.createRef();
    this.scrollContainerSpadegamingRef = React.createRef();
    this.scrollContainerPragmaticPlayRef = React.createRef();

    // in-memory session cache
    this._cache = new Map();
    this._controllers = []; // to store abort controllers for in-flight requests

    // initialize sanitized refs & state placeholders for GIS providers
    GIS_PROVIDERS.forEach((p) => {
      const safe = sanitizeKey(p);
      this[`scrollContainer_${safe}`] = React.createRef();
      this.state.gisGames = { ...this.state.gisGames, [safe]: [] };
      this.state.gisPagination = {
        ...this.state.gisPagination,
        [safe]: {
          current_page: 1,
          total_pages: 1,
          loading: true,
          itemsPerPage: 20,
        },
      };
      this.state.showMoreGis = { ...this.state.showMoreGis, [safe]: false };
    });

    // other initialization (if needed)
    this.itemsToShow = 5;
    this.sections = [
      "/assets/images/evolutionicon.png",
      "/assets/images/ezubi.png",
      "/assets/images/pragmatic.png",
      "/assets/images/netent.png",
      "/assets/images/novomatic.png",
    ];
    this.livecasino = [
      "/assets/images/live1.png",
      "/assets/images/live2.png",
      "/assets/images/live3.jpg",
      "/assets/images/live4.jpg",
      "/assets/images/live5.jpg",
      "/assets/images/live6.png",
    ];
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);

    // Bind new pagination handlers
    this.handleGisPagination = this.handleGisPagination.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
  } // end constructor

  // ----------------- in-class cache helpers -----------------
  getCacheForKey(key) {
    const mem = this._cache.get(key);
    if (mem) {
      if (Date.now() - mem.ts <= mem.ttl) return mem.data;
      this._cache.delete(key);
    }
    const stored = getLocalCache(key);
    if (stored !== null) {
      this._cache.set(key, { data: stored, ts: Date.now(), ttl: 300000 });
      return stored;
    }
    return null;
  }

  setCacheForKey(key, data, ttl = 300000) {
    this._cache.set(key, { data, ts: Date.now(), ttl });
    setLocalCache(key, data, ttl);
  }

  clearCacheForKey(key) {
    this._cache.delete(key);
    clearLocalCache(key);
  }

  // ----------------- cached fetch for GIS games -----------------
  fetchGisGames = async (
    provider,
    page = 1,
    perPage = 20,
    useCache = true,
    signal = null,
  ) => {
    const safe = sanitizeKey(provider);
    const cacheKey = `gis_${safe}_p${page}_l${perPage}`;

    if (useCache) {
      const cached = this.getCacheForKey(cacheKey);
      if (cached) {
        return {
          games: cached.games || [],
          pagination: cached.pagination || {
            current_page: page,
            total_pages: 1,
          },
        };
      }
    }

    try {
      const url = `https://bkk07.com/api/gis/gamesgis?provider=${encodeURIComponent(provider)}&page=${page}&limit=${perPage}`;
      const opts = signal ? { signal } : {};
      const res = await fetch(url, opts);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();

      if (json && json.success && Array.isArray(json.data) && json.pagination) {
        const result = {
          games: json.data,
          pagination: {
            current_page: json.pagination.currentPage || page,
            total_pages: json.pagination.totalPages || 1,
          },
        };
        this.setCacheForKey(cacheKey, result, 300000);
        return result;
      } else {
        const fallback = {
          games: json.data || [],
          pagination: { current_page: page, total_pages: 1 },
        };
        this.setCacheForKey(cacheKey, fallback, 60000);
        return fallback;
      }
    } catch (err) {
      console.error("fetchGisGames error", provider, err);
      // try to return stale raw localStorage payload if any
      try {
        const raw = localStorage.getItem(
          `gis_${sanitizeKey(provider)}_p${page}_l${perPage}`,
        );
        if (raw) {
          const parsed = JSON.parse(raw);
          if (parsed && parsed.data) return parsed.data;
        }
      } catch (e) {
        /* ignore */
      }
      return { games: [], pagination: { current_page: page, total_pages: 1 } };
    }
  };

  // ----------------- concurrency-limited helper -----------------
  fetchInBatches = async (items, workerFn, concurrency = 4) => {
    const results = [];
    const queue = items.slice();
    const workers = new Array(concurrency).fill(0).map(async () => {
      while (true) {
        let item;
        // synchronize queue access
        item = queue.shift();
        if (!item) break;
        try {
          const res = await workerFn(item);
          results.push({ item, res, err: null });
        } catch (err) {
          results.push({ item, res: null, err });
        }
      }
    });
    await Promise.all(workers);
    return results;
  };

  // ----------------- lifecycle methods -----------------
  async componentDidMount() {
    this._isMounted = true;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // ensure we use setState (avoid direct mutation)
    this.updateEnabledFeatures(this.props.finalState);

    // Get the logged state from localStorage when component mounts
    const loggedStatus = localStorage.getItem("logged") === "true";
    this.setState({ isLogged: loggedStatus });

    if (isMobile()) this.setState({ padding: "p-1" });

    // add events
    if (this.gridRef.current) {
      this.gridRef.current.addEventListener("scroll", this.checkScrollPosition);
      window.addEventListener("resize", this.checkScrollPosition);
    }

    const containerPlay = this.containerPlayRef.current;
    if (containerPlay) {
      containerPlay.addEventListener("mousedown", this.handleMouseDown);
      containerPlay.addEventListener("mouseleave", this.handleMouseLeave);
      containerPlay.addEventListener("mouseup", this.handleMouseUp);
      containerPlay.addEventListener("mousemove", this.handleMouseMove);
    }

    socket.on(C.USER_INFO, this.handleUserInfo);
    this.requestUserInfo();

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    // === Hot Games: loaded directly from hotGamesConfig.js (all hardcoded) ===
    try {
      const hotGames = HOT_GAMES_CONFIG.map((game) => ({
        ...game,
        game_icon: game.image,
        name: game.game_name,
      }));

      this.setState({
        jsHotGames: hotGames,
        huiduHotGames: hotGames,
      });
    } catch (err) {
      console.error("Error loading hot games from config:", err);
    } finally {
      this.setState({ loading1: false });
    }

    // === HUIDU Games: Use static config (no API call) ===
    try {
      this.setState({ huiduLoading: true });

      // Sort providers by order
      const sortedProviders = [...HOME_GAMES_CONFIG].sort(
        (a, b) => a.order - b.order,
      );

      // Initialize refs for each supplier
      sortedProviders.forEach((provider) => {
        if (!this[`scrollContainer_huidu_${provider.code}`]) {
          this[`scrollContainer_huidu_${provider.code}`] = React.createRef();
        }
      });

      // Set suppliers from static config
      const huiduSuppliers = sortedProviders.map((p) => ({
        code: p.code,
        name: p.name,
      }));
      this.setState({ huiduSuppliers });

      // Set games from static config (no API call needed)
      const huiduGamesMap = {};
      const huiduPaginationMap = {};
      const huiduShowMoreMap = {};

      sortedProviders.forEach((provider) => {
        huiduGamesMap[provider.code] = provider.games;
        huiduPaginationMap[provider.code] = {
          loading: false,
          current_page: 1,
          total_pages: 1,
        };
        huiduShowMoreMap[provider.code] = false;
      });

      this.setState({
        huiduGames: huiduGamesMap,
        huiduPagination: huiduPaginationMap,
        huiduShowMore: huiduShowMoreMap,
      });
    } catch (err) {
      console.error("Error loading static games config:", err);
    } finally {
      this.setState({ huiduLoading: false });
    }

    // === Load JS vendor games (optional cached pattern) ===
    const vendors = [
      "evolution2",
      "pragmatic",
      "spribe",
      "ezugi",
      "ideal",
      "microgaming",
      "Caleta",
      "hacksaw",
      "jili",
      "netent",
      "pragmaticlive",
      "bgaming",
      "live88",
      "Boldplay",
      "BGaming",
      "Octoplay",
      "Lucksome",
      "JDB",
      "No Limit City",
      "Hacksaw Gaming",
    ];

    // If you have a separate fetch for js vendor games, consider caching similarly.
    // For brevity we will still use your existing fetchJSGamesByVendor but you can wrap it with cache if desired.

    // === GIS providers: load in parallel batches (concurrency-limited) with cache ===
    const worker = async (prov) => {
      const safe = sanitizeKey(prov);
      // show provider-level loading skeleton
      this.setState((state) => ({
        gisPagination: {
          ...state.gisPagination,
          [safe]: { ...(state.gisPagination[safe] || {}), loading: true },
        },
      }));

      // setup abort controller for this request
      const controller = new AbortController();
      this._controllers.push(controller);

      try {
        const res = await this.fetchGisGames(
          prov,
          1,
          20,
          true,
          controller.signal,
        );
        this.setState((state) => ({
          gisGames: { ...state.gisGames, [safe]: res.games || [] },
          gisPagination: {
            ...state.gisPagination,
            [safe]: {
              current_page: res.pagination.current_page || 1,
              total_pages: res.pagination.total_pages || 1,
              loading: false,
              itemsPerPage: 20,
            },
          },
          showMoreGis: { ...state.showMoreGis, [safe]: false },
        }));
        return res;
      } catch (err) {
        console.error(`Error loading GIS ${prov}`, err);
        this.setState((state) => ({
          gisPagination: {
            ...state.gisPagination,
            [safe]: { ...(state.gisPagination[safe] || {}), loading: false },
          },
        }));
        return null;
      }
    };

    // choose concurrency (4 is a reasonable default)
    await this.fetchInBatches(GIS_PROVIDERS, worker, 7);

    // small delay then set isLoadGames false (UI no longer blocked)
    setTimeout(() => {
      this.setState({ isLoadGames: false });
    }, 300);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.finalState !== this.props.finalState) {
      this.updateEnabledFeatures(this.props.finalState);
    }
  }

  componentWillUnmount() {
    if (this.gridRef.current) {
      this.gridRef.current.removeEventListener(
        "scroll",
        this.checkScrollPosition,
      );
      window.removeEventListener("resize", this.checkScrollPosition);
    }
    const containerPlay = this.containerPlayRef.current;
    if (containerPlay) {
      containerPlay.removeEventListener("mousedown", this.handleMouseDown);
      containerPlay.removeEventListener("mouseleave", this.handleMouseLeave);
      containerPlay.removeEventListener("mouseup", this.handleMouseUp);
      containerPlay.removeEventListener("mousemove", this.handleMouseMove);
    }
    socket.off(C.USER_INFO, this.handleUserInfo);
    window.removeEventListener("resize", this.handleResize);
    // abort any in-flight fetches
    (this._controllers || []).forEach((c) => {
      try {
        c.abort();
      } catch (e) {
        /* ignore */
      }
    });
    this._isMounted = false;
  }

  // ----------------- misc helpers & handlers (kept largely as you had them) -----------------
  updateEnabledFeatures(finalState) {
    this.setState({
      enabledFeatures: {
        OneTouch: finalState?.OneTouch ?? true,
        pragmaticslots: finalState?.pragmaticslots ?? true,
        pragmaticslive: finalState?.pragmaticlive ?? true,
        spribe: finalState?.spribe ?? true,
        ezugi: finalState?.ezugi ?? true,
        ideal: finalState?.ideal ?? true,
        esport: finalState?.esport ?? true,
        microgaming: finalState?.microgaming ?? true,
        Pgsoft: finalState?.Caleta ?? true,
        Hacksaw: finalState?.hacksawgaming ?? true,
        jili: finalState?.jili ?? true,
        netent: finalState?.netent ?? true,
        bjboriginal: finalState?.originals ?? true,
        bgaming: finalState?.microgaming ?? true,
        Boldplay: finalState?.Boldplay ?? true,
        live88: finalState?.live88 ?? true,
        sevenMojos: finalState?.sevenMojos ?? true,
        Octoplay: finalState?.Octoplay ?? true,
        Evolution: finalState?.Evolution ?? true,
        JDB: finalState?.JDB ?? true,
        NoLimitCity: finalState?.NoLimitCity ?? true,
        Hacksaw_Gaming: finalState?.Hacksaw_Gaming ?? true,
        Lucksome: finalState?.Lucksome ?? true,
        Caleta: finalState?.Caleta ?? true,
        Lotto: finalState?.Caleta ?? true,
        ICONIC21: finalState?.Caleta ?? true,
        HoGaming: finalState?.Caleta ?? true,
        BGaming: finalState?.Caleta ?? true,
      },
    });
  }

  handleImageLiveCasinoLoad = (gameId) => {
    this.setState((prevState) => ({
      loadedLiveCasinoImages: new Set(prevState.loadedLiveCasinoImages).add(
        gameId,
      ),
    }));
  };

  requestUserInfo = () => {
    socket.emit(
      C.USER_INFO,
      encode({
        id: getUID(),
        coin: storage.getKey("coin") || "",
        rate: null,
        game: "all",
        first: true,
      }),
    );
  };

  handleUserInfo = (data) => {
    const decodedData = decode(data);
    if (decodedData.status) {
      const currentCoin = (
        localStorage.getItem("coin") ||
        storage.getKey("coin") ||
        "USDT"
      ).toLowerCase();
      const liveCredit = decodedData?.credit && decodedData.credit[currentCoin];
      if (liveCredit !== undefined && liveCredit !== null) {
        const normalizedCredit = String(liveCredit);
        localStorage.setItem("credit", normalizedCredit);
        storage.setKey("credit", normalizedCredit);
      }
      this.setState({ userData: decodedData });
    }
  };

  getLaunchCreditForCoin = (coinName) => {
    const selectedCoin = String(
      coinName ||
        localStorage.getItem("coin") ||
        storage.getKey("coin") ||
        "USDT",
    );
    const currentCoin = selectedCoin.toLowerCase();
    const liveCredit =
      this.state.userData?.credit && this.state.userData.credit[currentCoin];

    if (liveCredit !== undefined && liveCredit !== null) {
      const normalizedCredit = String(liveCredit);
      localStorage.setItem("credit", normalizedCredit);
      storage.setKey("credit", normalizedCredit);
      return normalizedCredit;
    }

    return localStorage.getItem("credit") || storage.getKey("credit") || "0";
  };

  // scroll helpers use sanitized refs
  handleScrollProvider = (provider, direction) => {
    const safe = sanitizeKey(provider);
    const ref = this[`scrollContainer_${safe}`];
    if (ref && ref.current) {
      ref.current.scrollBy({
        left: direction === "right" ? 400 : -400,
        behavior: "smooth",
      });
    }
  };

  handleScrollLeftHotGames = () => {
    if (this.scrollContainerHotGamesRef.current) {
      this.scrollContainerHotGamesRef.current.scrollBy({
        left: -400,
        behavior: "smooth",
      });
    }
  };

  handleScrollRightHotGames = () => {
    if (this.scrollContainerHotGamesRef.current) {
      this.scrollContainerHotGamesRef.current.scrollBy({
        left: 400,
        behavior: "smooth",
      });
    }
  };

  handleShowMoreGis = (provider) => {
    const safe = sanitizeKey(provider);
    this.setState((prevState) => ({
      showMoreGis: {
        ...prevState.showMoreGis,
        [safe]: !prevState.showMoreGis[safe],
      },
    }));
  };

  handleBackButton = () => {
    this.setState({ showIframe: false, iframeUrl: "", iframeLoading: true });
  };

  handleIframeLoad = () => {
    this.setState({ iframeLoading: false });
  };

  handleGameLaunchGis = async (provider, game) => {
    this.setState({ loading: true });
    try {
      if (GIS_PROVIDERS.includes(provider)) {
        const isMobile = this.state.isMobileView;
        const uid = getUID();
        const payload = {
          player_id: uid,
          player_name: localStorage.getItem("name") || "Player",
          game_uuid: game.uuid,
          currency:
            (localStorage.getItem("coin") === "USDT"
              ? "USD"
              : localStorage.getItem("coin") === "INR"
                ? "PKR"
                : localStorage.getItem("coin")) || "PKR",
          device: isMobile ? "mobile" : "desktop",
          return_url:
            "https://bkk07.com/api/gis/callback/transactions",
          language: "en",
        };

        const res = await fetch(
          "https://bkk07.com/api/gis/games/init",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );
        const js = await res.json();
        if (js.url) {
          this.setState({
            iframeUrl: js.url,
            showIframe: true,
            iframeLoading: true,
          });
        } else {
          sendNotfication(js.message || "Failed to launch GIS game", "error");
        }
      } else {
        // jsGames path
        const coins = localStorage.getItem("coin") || "USDT";
        const credits = this.getLaunchCreditForCoin(coins);
        if (!["USDT", "INR"].includes(coins)) {
          sendNotfication("Please swap into USDT to play", "error");
          return;
        }
        const payload = {
          game_uid: game.game_uid,
          user_id: getUID(),
          credit_amount: credits,
          currency_code: coins,
          language: "en",
        };
        const res = await fetch(
          "https://bkk07.com/jsGamesv2/launch",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );
        const js = await res.json();
        if (js.success && js.data?.game_launch_url) {
          this.setState({
            iframeUrl: js.data.game_launch_url,
            showIframe: true,
            iframeLoading: true,
          });
        } else {
          sendNotfication(js.message || "Failed to launch game", "error");
        }
      }
    } catch (err) {
      console.error("Launch error:", err);
      sendNotfication(err.message || "Unexpected error", "error");
    } finally {
      this.setState({ loading: false });
    }
  };

  // HUIDU game launch handler
  handleHuiduGameLaunch = async (game) => {
    const isLogged = localStorage.getItem("logged") === "true";
    if (!isLogged) {
      sendNotfication("Please login to play", "error");
      return;
    }
    this.setState({ loading: true });
    try {
      // Refresh balance from server before launching
      const coins = localStorage.getItem("coin") || "INR";

      const uid = getUID();
      // Send current localStorage credit as hint; backend will fetch real balance from DB
      const credits = this.getLaunchCreditForCoin(coins);

      const result = await launchHuiduGame(game.game_uid, uid, credits, coins, "en", game.supplier || "");
      if (result.success && result.game_launch_url) {
        this.setState({
          iframeUrl: result.game_launch_url,
          showIframe: true,
          iframeLoading: true,
        });
      } else {
        sendNotfication("Failed to launch game", "error");
      }
    } catch (err) {
      console.error("HUIDU launch error:", err);
      sendNotfication(err.message || "Game launch failed", "error");
    } finally {
      this.setState({ loading: false });
    }
  };

  // HUIDU show more/less toggle
  handleHuiduShowMore = (supplierCode) => {
    this.setState((prevState) => ({
      huiduShowMore: {
        ...prevState.huiduShowMore,
        [supplierCode]: !prevState.huiduShowMore[supplierCode],
      },
    }));
  };

  // Generic vendor pagination handler (used by Hot Games and possibly others)
  async handlePagination(vendorKey, direction = "next") {
    try {
      const vendorPagination = { ...(this.state.vendorPagination || {}) };
      const entry = vendorPagination[vendorKey] || {
        currentPage: 1,
        totalPages: 1,
        loading: false,
      };

      let nextPage = entry.currentPage;
      if (direction === "next")
        nextPage = Math.min(entry.totalPages, entry.currentPage + 1);
      else if (direction === "prev")
        nextPage = Math.max(1, entry.currentPage - 1);

      // nothing to do if page won't change
      if (nextPage === entry.currentPage) return;

      // set loading state
      this.setState((state) => ({
        vendorPagination: {
          ...state.vendorPagination,
          [vendorKey]: {
            ...(state.vendorPagination[vendorKey] || {}),
            loading: true,
            currentPage: nextPage,
          },
        },
      }));

      // Example: try to fetch hotgames (if vendorKey === 'hotgames') or simply log
      if (vendorKey === "hotgames") {
        // try to fetch hotgames with page param (server may or may not support page)
        try {
          const res = await fetch(
            `https://bkk07.com/api/gis/hotgames?page=${nextPage}`,
          );
          if (res.ok) {
            const js = await res.json();
            this.setState({ jsHotGames: js.data || [] });
          } else {
            console.warn("Hotgames page fetch failed", res.status);
          }
        } catch (err) {
          console.error("Hotgames pagination fetch error", err);
        }
      } else {
        // If you have vendor-specific fetch functions, call them here.
        console.warn(
          "handlePagination: no fetch implemented for vendor",
          vendorKey,
        );
      }
    } finally {
      // clear any loading flag for that vendor
      this.setState((state) => ({
        vendorPagination: {
          ...state.vendorPagination,
          [vendorKey]: {
            ...(state.vendorPagination[vendorKey] || {}),
            loading: false,
          },
        },
      }));
    }
  }

  // Pagination for GIS providers (previously missing)
  async handleGisPagination(provider, direction = "next") {
    const safe = sanitizeKey(provider);
    const pageInfo = this.state.gisPagination[safe] || {
      current_page: 1,
      total_pages: 1,
    };
    let nextPage = pageInfo.current_page;

    if (direction === "next") {
      if (
        pageInfo.total_pages &&
        pageInfo.current_page < pageInfo.total_pages
      ) {
        nextPage = pageInfo.current_page + 1;
      } else {
        nextPage = pageInfo.current_page; // no-op
      }
    } else if (direction === "prev") {
      nextPage = Math.max(1, pageInfo.current_page - 1);
    }

    if (nextPage === pageInfo.current_page) return; // nothing to do

    // set loading
    this.setState((state) => ({
      gisPagination: {
        ...state.gisPagination,
        [safe]: { ...(state.gisPagination[safe] || {}), loading: true },
      },
    }));

    const controller = new AbortController();
    this._controllers.push(controller);

    try {
      const res = await this.fetchGisGames(
        provider,
        nextPage,
        this.state.gisPagination[safe]?.itemsPerPage || 20,
        false,
        controller.signal,
      );
      // replace current page's games with fetched page
      this.setState((state) => ({
        gisGames: { ...state.gisGames, [safe]: res.games || [] },
        gisPagination: {
          ...state.gisPagination,
          [safe]: {
            ...(state.gisPagination[safe] || {}),
            current_page: res.pagination?.current_page || nextPage,
            total_pages:
              res.pagination?.total_pages ||
              state.gisPagination[safe]?.total_pages ||
              1,
            loading: false,
          },
        },
      }));
      // optionally scroll to top of that provider container
      const ref = this[`scrollContainer_${safe}`];
      if (ref && ref.current) ref.current.scrollLeft = 0;
    } catch (err) {
      console.error("handleGisPagination error", provider, err);
      // clear loading on failure
      this.setState((state) => ({
        gisPagination: {
          ...state.gisPagination,
          [safe]: { ...(state.gisPagination[safe] || {}), loading: false },
        },
      }));
    }
  }

  // many of your existing scroll, showMore, mouse handlers etc. remain the same;
  // ensure they reference sanitized keys or existing refs as needed.
  handleMouseDown(e) {
    this.isDown = true;
    this.startX = e.pageX - this.containerPlayRef.current.offsetLeft;
    this.scrollLeft = this.containerPlayRef.current.scrollLeft;
  }
  handleMouseLeave() {
    this.isDown = false;
  }
  handleMouseUp() {
    this.isDown = false;
  }
  handleMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.containerPlayRef.current.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.containerPlayRef.current.scrollLeft = this.scrollLeft - walk;
  }

  checkScrollPosition = () => {
    if (this.gridRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = this.gridRef.current;
      this.setState({
        canScrollLeft: scrollLeft > 0,
        canScrollRight: Math.ceil(scrollLeft) < scrollWidth - clientWidth,
      });
    }
  };

  handleResize = () => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.setState({ isMobileView: width <= 768 });
  };

  handleClick = (e) => {
    this.setState({ selectedSection: e });
  };

  // ----------------- render -----------------
  render() {
    const { content, t, siteConfig } = this.props;
    const { canScrollLeft, canScrollRight, isLogged } = this.state;
    const {
      loading,
      message,
      isMobileView,
      showIframe,
      enabledFeatures,
      iframeUrl,
      iframeLoading,
    } = this.state;

    // compute activeGisProviders based on enabledFeatures + FEATURE_MAP mapping
    const activeGisProviders = GIS_PROVIDERS.filter(
      (provider) => !!enabledFeatures[FEATURE_MAP[provider]],
    );

    // top-level immediate content: if iframe open, show it full-screen
    if (showIframe) {
      const animationStyle = `
        @keyframes fadeinout {
          0%, 100% { opacity: 0; }
          50% { opacity: 1; }
        }
      `;
      const imageStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "250px",
        animation: "fadeinout 2s infinite",
      };
      return (
        <FullScreenContainer>
          <style>{animationStyle}</style>
          {iframeLoading && (
            <img src="assets/images/lg.png" alt="Loading" style={imageStyle} />
          )}
          <FullScreenIframe
            src={iframeUrl}
            title="Game Iframe"
            onLoad={this.handleIframeLoad}
            loading={iframeLoading}
          />
          <BackButton onClick={this.handleBackButton}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </BackButton>
        </FullScreenContainer>
      );
    }

    return (
      <>
        {this._isMounted && (
          <>
            <Helmet>
              <title>{BRAND} - Crypto Casino Games and Crypto Gambling</title>
              <meta
                name="keywords"
                content="WEB 3.0 Crypto Casino Games, Online Casino Games, Bitcoin Crash Game, Dice Games, Live Casino Games, Crypto Casino Games, Blockchain Games, Bitcoin Casino Games, Best Crypto Online Game, Crypto Gambling Games"
              />
              <meta
                name="description"
                content="PlayCrash.com is built by gamblers for gamblers. With our unique community and a huge selection of games like Crash, HashDice, Plinko, Slots, and many more."
              />
              <meta
                name="og:title"
                content="PlayCrash.com is built by gamblers for gamblers. With our unique community and a huge selection of games like Crash, HashDice, Plinko, Slots, and many more."
              />
              <meta
                name="og:description"
                content="PlayCrash.com is built by gamblers for gamblers. With our unique community and a huge selection of games like Crash, HashDice, Plinko, Slots, and many more."
              />
            </Helmet>

            {content}

            <div style={{ marginTop: "-10px" }}>
              {isLogged ? <SkylaSlider /> : <Banner />}
              {/* <SportsBanner /> */}
              <LatestWins
                all={[...this.state.jsPragmeticSlots]}
                slots={this.state.jsPragmeticSlots}
                liveCasino={this.state.jsPragmeticSlots}
              />
              <GamingCards />

              {/* Hot Games Section (keeps previous logic) */}
              <div style={{ marginTop: "6px", marginBottom: "20px" }}>
                <HeaderContainer>
                  <TopTitle>Hot Games</TopTitle>
                  <HeaderContent>
                    <div
                      onClick={() =>
                        this.setState({
                          showMoreHotGames: !this.state.showMoreHotGames,
                        })
                      }
                    >
                      <IconBg>
                        <div style={{ fontWeight: "bold" }}>
                          {this.state.showMoreHotGames
                            ? "Show Less"
                            : "Show More"}
                        </div>
                      </IconBg>
                    </div>
                    {!this.state.showMoreHotGames && (
                      <div style={{ display: "flex", gap: "4px" }}>
                        <IconBg onClick={this.handleScrollLeftHotGames}>
                          <ChevronLeft size={16} />
                        </IconBg>
                        <IconBg onClick={this.handleScrollRightHotGames}>
                          <ChevronRight size={16} />
                        </IconBg>
                      </div>
                    )}
                  </HeaderContent>
                </HeaderContainer>

                {this.state.loading1 ? (
                  this.state.showMoreHotGames ? (
                    <GridWrapper>
                      {Array.from({ length: 15 }).map((_, i) => (
                        <SkeletonCard key={i} />
                      ))}
                    </GridWrapper>
                  ) : (
                    <CarouselContainer>
                      <ScrollContainer>
                        {Array.from({ length: 15 }).map((_, i) => (
                          <div key={i} style={{ marginRight: "8px" }}>
                            <SkeletonCard />
                          </div>
                        ))}
                      </ScrollContainer>
                    </CarouselContainer>
                  )
                ) : !this.state.showMoreHotGames ? (
                  <CarouselContainer>
                    <ScrollContainer ref={this.scrollContainerHotGamesRef}>
                      {this.state.jsHotGames?.map((game, index) => (
                        <GameCard
                          key={`hot-${game.id || game.game_uid}-${index}`}
                          onClick={() =>
                            game.game_uid
                              ? this.handleHuiduGameLaunch(game)
                              : this.handleGameLaunchGis("hotgames", game)
                          }
                        >
                          {game.game_icon || game.image ? (
                            <GameImageWithFallback
                              src={game.game_icon || game.image}
                              alt={
                                game.game_name ||
                                game.name ||
                                `Hot Game ${index}`
                              }
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                background:
                                  "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
                                borderRadius: "8px",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              <PlayIcon
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  color: "#fff",
                                  marginBottom: "8px",
                                }}
                              />
                              <span
                                style={{
                                  color: "#fff",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  lineHeight: "1.3",
                                  wordBreak: "break-word",
                                }}
                              >
                                {game.game_name || game.name}
                              </span>
                            </div>
                          )}
                          <GameOverlay>
                            <PlayIconContainer>
                              <PlayIcon />
                            </PlayIconContainer>
                          </GameOverlay>
                        </GameCard>
                      ))}
                    </ScrollContainer>
                  </CarouselContainer>
                ) : (
                  <>
                    <GridWrapper>
                      {this.state.jsHotGames?.map((game, index) => (
                        <GameCard
                          key={`hot-${game.id || game.game_uid}-${index}`}
                          onClick={() =>
                            game.game_uid
                              ? this.handleHuiduGameLaunch(game)
                              : this.handleGameLaunchGis("hotgames", game)
                          }
                        >
                          {game.game_icon || game.image ? (
                            <GameImageWithFallback
                              src={game.game_icon || game.image}
                              alt={
                                game.game_name ||
                                game.name ||
                                `Hot Game ${index}`
                              }
                            />
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                background:
                                  "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
                                borderRadius: "8px",
                                padding: "8px",
                                textAlign: "center",
                              }}
                            >
                              <PlayIcon
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  color: "#25ee89",
                                  marginBottom: "8px",
                                }}
                              />
                              <span
                                style={{
                                  color: "#fff",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  lineHeight: "1.3",
                                  wordBreak: "break-word",
                                }}
                              >
                                {game.game_name || game.name}
                              </span>
                            </div>
                          )}
                          <GameOverlay>
                            <PlayIconContainer>
                              <PlayIcon />
                            </PlayIconContainer>
                          </GameOverlay>
                        </GameCard>
                      ))}
                    </GridWrapper>
                    <PaginationContainer>
                      <PaginationButton
                        onClick={() =>
                          this.handlePagination("hotgames", "prev")
                        }
                        disabled={
                          this.state.vendorPagination.hotgames.currentPage <=
                            1 || this.state.vendorPagination.hotgames.loading
                        }
                      >
                        <ChevronLeft size={16} /> Previous
                      </PaginationButton>
                      <PaginationInfo>
                        Page {this.state.vendorPagination.hotgames.currentPage}{" "}
                        of {this.state.vendorPagination.hotgames.totalPages}
                      </PaginationInfo>
                      <PaginationButton
                        onClick={() =>
                          this.handlePagination("hotgames", "next")
                        }
                        disabled={
                          this.state.vendorPagination.hotgames.currentPage >=
                            this.state.vendorPagination.hotgames.totalPages ||
                          this.state.vendorPagination.hotgames.loading
                        }
                      >
                        Next <ChevronRight size={16} />
                      </PaginationButton>
                      {this.state.vendorPagination.hotgames.loading && (
                        <Spinner size="sm" />
                      )}
                    </PaginationContainer>
                  </>
                )}
              </div>

              <SkylaPromoSlider />

              {/* HUIDU Games Section — Static config, each provider gets its own row */}
              {this.state.huiduSuppliers.length > 0 &&
                this.state.huiduSuppliers.map((supplier, supplierIndex) => {
                  const games = this.state.huiduGames[supplier.code] || [];
                  const showMore =
                    this.state.huiduShowMore[supplier.code] || false;
                  const supplierName = supplier.name || supplier.code;

                  if (games.length === 0) return null;

                  return (
                    <LazySection
                      key={`huidu-${supplier.code}`}
                      eager={supplierIndex === 0}
                      minHeight={300}
                    >
                      <div style={{ marginTop: "6px" }}>
                        <HeaderContainer>
                          <TopTitle>{supplierName}</TopTitle>
                          <HeaderContent>
                            <div
                              onClick={() =>
                                this.handleHuiduShowMore(supplier.code)
                              }
                            >
                              <IconBg>
                                <div style={{ fontWeight: "bold" }}>
                                  {showMore ? "Show Less" : "Show More"}
                                </div>
                              </IconBg>
                            </div>
                            {!showMore && (
                              <div style={{ display: "flex", gap: "4px" }}>
                                <IconBg
                                  onClick={() => {
                                    const ref =
                                      this[
                                        `scrollContainer_huidu_${supplier.code}`
                                      ];
                                    if (ref && ref.current)
                                      ref.current.scrollBy({
                                        left: -400,
                                        behavior: "smooth",
                                      });
                                  }}
                                >
                                  <ChevronLeft size={16} />
                                </IconBg>
                                <IconBg
                                  onClick={() => {
                                    const ref =
                                      this[
                                        `scrollContainer_huidu_${supplier.code}`
                                      ];
                                    if (ref && ref.current)
                                      ref.current.scrollBy({
                                        left: 400,
                                        behavior: "smooth",
                                      });
                                  }}
                                >
                                  <ChevronRight size={16} />
                                </IconBg>
                              </div>
                            )}
                          </HeaderContent>
                        </HeaderContainer>

                        {showMore ? (
                          <GridWrapper>
                            {games.map((game, gameIndex) => {
                              const imageUrl =
                                game.image || game.game_icon || "";
                              return (
                                <GameCard
                                  key={game.game_uid}
                                  onClick={() =>
                                    this.handleHuiduGameLaunch(game)
                                  }
                                >
                                  {imageUrl ? (
                                    <GameImageWithFallback
                                      src={imageUrl}
                                      alt={game.game_name}
                                    />
                                  ) : (
                                    <div
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        background:
                                          "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
                                        borderRadius: "8px",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <PlayIcon
                                        style={{
                                          width: "28px",
                                          height: "28px",
                                          color: "#25ee89",
                                          marginBottom: "8px",
                                        }}
                                      />
                                      <span
                                        style={{
                                          color: "#fff",
                                          fontSize: "11px",
                                          fontWeight: "600",
                                          lineHeight: "1.3",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {game.game_name}
                                      </span>
                                    </div>
                                  )}
                                  <GameOverlay>
                                    <PlayIconContainer>
                                      <PlayIcon />
                                    </PlayIconContainer>
                                  </GameOverlay>
                                </GameCard>
                              );
                            })}
                          </GridWrapper>
                        ) : (
                          <CarouselContainer>
                            <ScrollContainer
                              ref={
                                this[`scrollContainer_huidu_${supplier.code}`]
                              }
                            >
                              {games.map((game, gameIndex) => {
                                const imageUrl =
                                  game.image || game.game_icon || "";
                                return (
                                  <GameCard
                                    key={game.game_uid}
                                    onClick={() =>
                                      this.handleHuiduGameLaunch(game)
                                    }
                                  >
                                    {imageUrl ? (
                                      <GameImageWithFallback
                                        src={imageUrl}
                                        alt={game.game_name}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          background:
                                            "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
                                          borderRadius: "8px",
                                          padding: "8px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <PlayIcon
                                          style={{
                                            width: "28px",
                                            height: "28px",
                                            color: "#fff",
                                            marginBottom: "8px",
                                          }}
                                        />
                                        <span
                                          style={{
                                            color: "#fff",
                                            fontSize: "11px",
                                            fontWeight: "600",
                                            lineHeight: "1.3",
                                            wordBreak: "break-word",
                                          }}
                                        >
                                          {game.game_name}
                                        </span>
                                      </div>
                                    )}
                                    <GameOverlay>
                                      <PlayIconContainer>
                                        <PlayIcon />
                                      </PlayIconContainer>
                                    </GameOverlay>
                                  </GameCard>
                                );
                              })}
                            </ScrollContainer>
                          </CarouselContainer>
                        )}
                      </div>
                    </LazySection>
                  );
                })}
              <CustomSlider />

              {/* <SportsBanner /> */}
              {/* <Sports /> */}
              {/* <GamingCards /> */}

              {/* GIS Providers: HIDDEN — replaced by HUIDU API providers above */}
              {/* activeGisProviders.map(provider => {
                const safe = sanitizeKey(provider);
                const allGames = this.state.gisGames[safe] || [];
                const pageInfo = this.state.gisPagination[safe] || { current_page: 1, total_pages: 1, loading: true };
                const isLoading = !!pageInfo.loading;
                const displayGames = allGames;
                const skeletonCount = this.state.showMoreGis[safe] ? 12 : 8;

                return (
                  <div key={safe} style={{ marginTop: '6px' }}>
                    <HeaderContainer>
                      <TopTitle>{provider === 'Evolution2' ? 'Evolution' : provider === 'EVOASIA' ? 'Evolution Gaming' : provider}</TopTitle>
                      <HeaderContent>
                        <div onClick={() => this.handleShowMoreGis(provider)}><IconBg><div style={{ fontWeight: "bold" }}>{this.state.showMoreGis[safe] ? "Show Less" : "Show More"}</div></IconBg></div>
                        {!this.state.showMoreGis[safe] && (
                          <div style={{ display: "flex", gap: '4px' }}>
                            <IconBg onClick={() => this.handleScrollProvider(provider, 'left')}><ChevronLeft size={16} /></IconBg>
                            <IconBg onClick={() => this.handleScrollProvider(provider, 'right')}><ChevronRight size={16} /></IconBg>
                          </div>
                        )}
                      </HeaderContent>
                    </HeaderContainer>

                    {this.state.showMoreGis[safe] ? (
                      <GridWrapper>
                        {isLoading ? Array.from({ length: skeletonCount }).map((_, idx) => <GameCard key={`skeleton-${safe}-${idx}`}><SkeletonCard /></GameCard>) : displayGames.map(g => (
                          <GameCard key={g.uuid || g.id} onClick={() => this.handleGameLaunchGis(provider, g)}>
                            <GameImageWithFallback src={g.image} alt={g.name} />
                            <GameOverlay><PlayIconContainer><PlayIcon /></PlayIconContainer></GameOverlay>
                          </GameCard>
                        ))}
                      </GridWrapper>
                    ) : (
                      <CarouselContainer>
                        <ScrollContainer ref={this[`scrollContainer_${safe}`]}>
                          {isLoading ? Array.from({ length: skeletonCount }).map((_, idx) => <GameCard key={`skeleton-carousel-${safe}-${idx}`}><SkeletonCard /></GameCard>) : displayGames.map(g => (
                            <GameCard key={g.uuid || g.id} onClick={() => this.handleGameLaunchGis(provider, g)}>
                              <GameImageWithFallback src={g.image} alt={g.name} />
                              <GameOverlay><PlayIconContainer><PlayIcon /></PlayIconContainer></GameOverlay>
                            </GameCard>
                          ))}
                        </ScrollContainer>
                      </CarouselContainer>
                    )}

                    {this.state.showMoreGis[safe] && (
                      <PaginationContainer>
                        <PaginationButton onClick={() => this.handleGisPagination(provider, 'prev')} disabled={pageInfo.current_page <= 1 || pageInfo.loading}><ChevronLeft size={16} /> Previous</PaginationButton>
                        <PaginationInfo>Page {pageInfo.current_page} of {pageInfo.total_pages}</PaginationInfo>
                        <PaginationButton onClick={() => this.handleGisPagination(provider, 'next')} disabled={pageInfo.current_page >= pageInfo.total_pages || pageInfo.loading}>Next <ChevronRight size={16} /></PaginationButton>
                        {pageInfo.loading && <Spinner size="sm" />}
                      </PaginationContainer>
                    )}
                  </div>
                );
              })} */}

              <div style={{ marginTop: "24px" }}>
                {!isMobile() ? <PaymentBar /> : <MobilePaymentBR />}
              </div>
              {/* Lobby and BJB Originals: HIDDEN — replaced by HUIDU API providers */}
              {/* enabledFeatures.lobby && <LobbySection /> */}
              {/* enabledFeatures.bjboriginal && <Games currentPage="home" t={t} /> */}
            </div>
          </>
        )}

        <div style={{ marginTop: "1rem" }}>
          <TopTitle>Recent Wins</TopTitle>
        </div>
        <CasinoLeaderboard />

        {loading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
            }}
          >
            <Spinner size="sm" />
          </div>
        )}

        {message && (
          <Alert
            variant={message.type === "error" ? "danger" : "success"}
            style={{
              position: "fixed",
              bottom: 20,
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 9999,
            }}
          >
            {message.text}
          </Alert>
        )}
      </>
    );
  }
}

// Wrap Home with redux finalState prop in a functional component
function HomeWithContext(props) {
  const finalState = useSelector((state) => state.finalState.finalState);
  return <Home {...props} finalState={finalState} />;
}

export default withCookies(HomeWithContext);
